import { locoTypeDetailed } from '@app/pcs/models';
import {gql} from 'apollo-angular';

export const updateLocoTypeResult = 'updateLocoType';
export const updateLocoTypeMutation = gql`
  mutation UpdateLocoType($locoType: LocoTypeInput!) {
    updateLocoType (locoType: $locoType) {
      ...locoTypeDetailed
    }
  }
  ${locoTypeDetailed}
`;

export const copyLocoTypes = 'copyAgencyParameters';
export const copyLocoTypesMutation = gql`
  mutation CopyLocoTypes($locoTypeIds: [Long]!, $ttpId: Long!) {
    copyLocoType (locoTypeIds: $locoTypeIds, ttpId: $ttpId) {
      id
    }
  }
`;

export const deleteLocoTypes = 'deleteLocoType';
export const deleteLocoTypesMutation = gql`
  mutation DeleteLocoType($locoTypeIds: [Long]!) {
    deleteLocoType (locoTypeIds: $locoTypeIds) {
      ...locoTypeDetailed
    }
  }
  ${locoTypeDetailed}
`;
